export default __webpack_public_path__ + "static/media/ssrailing.607b3593.jpg";